import SystemEnum from '@/assets/js/systemEnum'
import DataType from '@/util/dataType'
const WORK_QUEUE = SystemEnum.WORK_QUEUE_ENUM
const MISCELLANEOUS_QUEUE = [
  {
    status: WORK_QUEUE.MISCELLANEOUS.value,
    title: WORK_QUEUE.MISCELLANEOUS.text,
    key: WORK_QUEUE.MISCELLANEOUS.key,
    features: WORK_QUEUE.MISCELLANEOUS.features,
    code: DataType.PrivilegeCode.MISCELLANEOUS,
    color: ['#685DE8', '#F3F2FD'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  }
]
export default MISCELLANEOUS_QUEUE
